import React from 'react';
import { useTranslation } from 'react-i18next';

const ErrorFallBackComponent = () => {
    const { t } = useTranslation();
    return (
        <div role="alert">
            <pre style={{ color: "red" }}>{t(`somethingWentWrong`)}</pre>
        </div>);
};
 
export default ErrorFallBackComponent;